import React from "react";
import { useState } from "react";
import "./Contact_Us.css";
import Header_Banner from "../common-components/common_banner/header_banner/Header_Banner";
import Complete_Medical from "../common-components/common_banner/complete_medical/Complete_Medical";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Redirect_btn from "../common-components/common-btn/redirect-btn/Redirect_btn";
import { Success_lottie } from "../lotties/success_lottie/Success_lottie";
import Full_screen_modal from "../common-components/full_screen_modal/Full_screen_modal";
import Location_animation from "../common-components/location_animation/Location_animation";

const Contact_Us = () => {
  const breadcrumbs = [
    { label: "Home", link: "/about-us", isActive: false },
    { label: "CONTACT US", link: "", isActive: true },
  ];

  const [formSubmitted, setFormSubmitted] = useState(false);
  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.number}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "pradnyagawande85@gmail.com",
        subject: "Shore Clinic Inquiry",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 2500);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  return (
    <section className="contact_us_section">
      <Header_Banner
        imgSrc={"assets/images/contact-us/contact-banner.png"}
        title_text="Contact Us"
        breadcrumbs={breadcrumbs}
      />
      <div className="contact_section">
        <Container>
          <div className="contact_div">
            <div className="card_div">
              <Row className="justify-content-center">
                <Col lg={3} md={4} sm={6} className="mb-4">
                  <div className="contact_card">
                    <div className="icon_circle">
                      <img
                        src="/assets/images/contact-us/path.png"
                        className="icons"
                      />
                    </div>
                    <h5 className="card_title">Location</h5>
                    <p className="card_text">
                      office No.1, Sr.no.209, Dnyanesh Height, near shivaji
                      maharaj statue, kothrud, Pune-411038
                    </p>
                  </div>
                </Col>

                <Col lg={3} md={4} sm={6} className="mb-4">
                  <div className="contact_card">
                    <div className="icon_circle">
                      <img
                        src="./assets/images/contact-us/mail.png"
                        className="icons"
                      />
                    </div>
                    <h5 className="card_title">Email Address</h5>
                    <p className="card_text">pradnyagawande85@gmail.com </p>
                  </div>
                </Col>

                <Col lg={3} md={4} sm={6} className="mb-4">
                  <div className="contact_card">
                    <div className="icon_circle">
                      <img
                        src="./assets/images/contact-us/phone-call.png"
                        className="icons"
                      />
                    </div>
                    <h5 className="card_title">Phone Number</h5>
                    <p className="card_text">+91- 8793449778 / +91- 8208520589</p>
                  </div>
                </Col>

                <Col lg={3} md={4} sm={6} className="mb-4">
                  <div className="contact_card">
                    <div className="icon_circle">
                      <img
                        src="./assets/images/contact-us/Clock.png"
                        className="icons"
                      />
                    </div>
                    <h5 className="card_title">Working Hours</h5>
                    <p className="card_text">
                      Mon - Sat : 10:00 AM to 6:00 PM <br /> Sunday: Closed
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            <Row className="justify-content-center ">
              <Col md={7}>
                <div className="contact_form_card">
                  <h3 className="form_title">Get in Touch</h3>

                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Your Full Name"
                        {...register("name", {
                          required: "Name is required",
                        })}
                        className={classNames("form-input", {
                          "is-valid": getValues("name"),
                        })}
                      />
                      {errors?.name && (
                        <span className="invalid-feedback d-block">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="number"
                        placeholder="Enter Your Contact Number"
                        {...register("number", {
                          required: "Contact Number is required",
                          pattern: {
                            message: "Invalid Contact Number",
                          },
                        })}
                        className={classNames("form-input", {
                          "is-invalid": errors?.number,
                          "is-valid": getValues("number"),
                        })}
                      />
                      {errors?.number && (
                        <span className="invalid-feedback d-block">
                          {errors.number.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        as={"textarea"}
                        type="text"
                        name="message"
                        placeholder="Enter your message"
                        {...register("message", {
                          required: "Message is required",
                        })}
                        className={classNames("form-input", {
                          "is-invalid": errors?.message,
                          "is-valid": getValues("message"),
                        })}
                      />
                      {errors?.message && (
                        <span className="invalid-feedback d-block">
                          {errors.message.message}
                        </span>
                      )}
                    </Form.Group>
                    <div className="button">
                      {!formSubmitted && (
                        <Redirect_btn name="Send message" hideIcon={true} />
                      )}
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <div className="map">
          <iframe
            className="gmap_iframe"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
            title="Google Map"
            loading="lazy"
            allowFullScreen
          ></iframe>

          <div className="view_div">
            <div className="location_div">
              <Location_animation />
            </div>
          </div>
        </div>
      </div>
      <Complete_Medical />
      <Full_screen_modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Success_lottie />}
      />
    </section>
  );
};

export default Contact_Us;
